export default {
  ADD_NEW_PLAYER: "add new player",
  ADD_NEW_TEAM: "add new team",
  ADD_TEAM: "add team",
  ADD_TITLE: "add title", 
  ALL_SPORTS: "all sports",  
  ALL_TEAMS: "all teams",
  ALREADY_HAVE_ACCOUNT: "already have MyPlay account", 
  ASSIGN_MYSELF_AS_COACH: "assign myself as team coach",
  ASSIGN_NEW_COACH: "assign new coach",
  ASSGIN_OPERATOR_WARNING: "are tou sure you want to make", 
  ASSIGN_TEAM: "assign team", 
  ATHLETES: "athletes",
  BACK: "back",
  GO_TO_MYPLAY: "go to MyPlay",  
  BY: "by",
  CANCEL_LIVE: "cancel live",  
  CHANGE: "change", 
  CHOOSE_TEAM: "choose team",
  CHOOSE_TEAM_WARNING: "please choose team first",
  CLEAR_FILTERS: "clear filters", 
  CLOSE: "close",  
  COACHES: "coaches",
  COACH_ALREADY_IN_TEAM: "coach is already assigned to this team", 
  COACH_REMOVED_SUCCESSFULLY: "coach was successfully removed",
  CONNECT_TO_SITE: "connect to site",
  COPIED_TO_CLIPBOARD: "copied to clipboard", 
  COUNTRY: "country", 
  COURT: "court",
  DASHBOARD: "dashboard",
  DATE_OF_BIRTH: "date of birth", 
  DELETE_SCHEDULED_TASK_CONFIRMATION: "are you sure you want to cancel this task?", 
  DELETE_TEAM_CONFIRMATION: "are you sure you want to delete ",
  DISCARD: "discard",
  DOWNLOAD_STARTED: "email with a link to download the recording will be sent to you in the next couple of minutes.",
  EDIT_TEAM: "edit team",
  FILTER: "filter", 
  FROM_YOUTUBE: "from youtube", 
  FROM_COMPUTER: "from computer", 
  GAME_SHARED_SUCCESS: "the game was successfully shared with ",
  GO_TO_LIVE: "go to live", 
  HIGHLIGHTS: "highlights",
  HIGHLIGHTS_RECORDED: "highlights recorded",
  IS_THIS_YOUR_VIDEO: "is this your video?",  
  INVALID_DATE: "invalid date",
  INVALID_PHONE: "invalid phone",
  INVITE_NEW_ATHLETE: "invite new athlete",
  INVITE_NEW_COACH: "invite new coach",
  INVITATION_SENT: "invitation was sent successfully to ",
  IRREVERSIBLE_OPERATION_WARNING: "this operation is irreversible",  
  IS_NOW_OPERATOR: "is now operator", 
  LAST_MONTH: "last month", 
  LAST_NAME: "last name", 
  LIVE_NOW: "live now",
  LOAD_MORE: "load more",
  LOAD_MORE_HIGHLIGHTS_ERROR: "no more highlights to load", 
  LOAD_MORE_VIDEOS_ERROR: "no more videos to load",   
  LOGOUT: "logout", 
  MAIN_COURT: "main court", 
  MY_ATHLETES: "my athletes",
  MY_TEAMS: "my teams",
  NAME: "name", 
  NEXT_RECORDING: "next recording",
  NO: "no",  
  NO_RECORDINGS_SCHEDULED: "no recordings scheduled",
  NO_RESULT_FOUND: "no result found",
  OFFLINE: "offline",
  OPERATOR: "operator", 
  PASTE_LINK:"paste link here", 
  PHONE: "phone",  
  REC: "rec",
  RECENT_ACTIVITY: "recent activity",
  RECENT_STATS: "recent stats",
  RECENT_VIDEOS: "recent videos", 
  RECORD_CREATED_SUCCESSFULLY: "record created successfully",
  RECORD_DELETED_SUCCESSFULLY: "record deleted successfully",
  RECORDING: "recording",
  RECORDING_SCHEDULE: "recording schedule",
  SAVE: "save",
  SAVE_CHANGES: "save changes", 
  SCHEDULE_ANOTHER: "schedule another recording",
  SCHEDULE_DUPLICATION_ERROR: "there is already another record scheduled to this date and time",  
  SCHEDULE_SUCCESS: "record was sucssesfully scheduled",
  SEARCH: "search",   
  SEARCH_ATHLETE: "search athlete",
  SEARCH_TEAM: "search team",
  SEARCH_VIDEO: "search video", 
  SEASON: "season",
  SEASONAL_AVERAGE: "seasonal average",
  SEE_ALL: "see all", 
  SHORT_NAME_ERROR: "at least 2 characters", 
  SITES: "sites",
  SOMETHING_WENT_WRONG: "something went wrong", 
  SPORT: "sport",
  STARTED_UPLOAD: "started upload", 
  STARTED_UPLOAD_YOUTUBE: "started upload from youtube", 
  START_GENERATING: "start generating",
  STOP: "stop", 
  STOP_LIVE: "stop live",
  SWITCH_CLUB: "switch club",  
  TEAMS: "teams",
  TEAM_CODE: "team code",
  TEAM_COACHES: "team coaches", 
  TEAM_NAME: "team name",
  TEAM_ROSTER: "team roster",
  TEAM_VIDEOS: "team videos",  
  TODAY: "today", 
  UPDATE_CLUB_LOGO: "update club logo",
  UPLOAD: "upload", 
  UPLOAD_VIDEO: "upload video",
  UPLOADING: "uploading video...", 
  UPLOAD_VIDEO_FROM_COMPUTER:"upload file direct from your device",
  UPLOAD_VIDEO_TO_TEAM_CHANNEL: "upload video to your team channel", 
  USERS: "users",  
  VIDEOS: "videos", 
  VIDEOS_RECORDED: "videos recorded", 
  YES: "yes", 
  YOUTUBE_URL_ERROR: "please insert a valid YouTube link"
};
